<template>
    <div
        class="bodycontent"
        id="main-container"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
        <el-aside>
            <div>
                <div class="leftcontent">
                    <div class="avatar-icon">
                        <img :src="avatar" class="avatar" />
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#iconzhuanjia" />
                        </svg>
                    </div>
                    <p class="name">{{name}}</p>
                    <div class="leftmid">
                        <p class="city">{{city}}</p>
                        <div class="line"></div>
                        <p class="city">{{job}}</p>
                    </div>
                    <p class="label">{{describe}}</p>
                    <p class="website">{{website}}</p>
                    <div class="buttoncontent">
                        <el-button class="contact" type="success" @click="toChat" round>咨询</el-button>
                        <el-button class="contact" type="primary" @click="setFollow" round>
                            <span v-if="info.isfollow">已</span>关注
                        </el-button>
                    </div>
                    <el-divider></el-divider>
                    <div class="labelcontent left">
                        <p class="labelmid">
                            <b>标签</b>
                        </p>
                        <div class="label haslittle">
                            <div
                                class="littlelabel"
                                v-for="label in labellist"
                                :key="label.index"
                            >{{label.lname}}</div>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="achievementcontent">
                        <p class="success">
                            <b>主要成就</b>
                        </p>
                        <p class="successtext">{{achievement}}</p>
                    </div>
                </div>
                <div class="leftbottom">
                    <div class="focus">
                        <p class="focustext">关注了</p>
                        <p class="num">{{focusnum}}</p>
                    </div>
                    <div class="focus">
                        <p class="focustext">粉丝</p>
                        <p class="num">{{fansnum}}</p>
                    </div>
                </div>
            </div>
        </el-aside>
        <el-main>
            <expertcollection v-if="show"></expertcollection>
            <chat :info="info" ref="chat" @close="show=true"></chat>
        </el-main>
        <el-dialog
            :visible.sync="buyDialog"
            width="35%"
            center
            :close-on-click-modal="false"
            :lock-scroll="true"
        >
            <span slot="title" class="dialog-title">咨询{{name}}</span>
            <div class="dialog-contianer">
                <div class="dialog-amount">
                    应付金额：
                    <span>{{ info.price }}</span>
                </div>
                <div class="dialog-btn" v-if="!insufficient">
                    <el-button type="primary" @click="payCreate(3)" round>确定咨询</el-button>
                </div>
                <div class="dialog-btn" v-else>
                    <el-button round @click="payWx">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-wx-tx" />
                        </svg>
                        微信支付
                    </el-button>
                    <el-button round @click="payCreate(2)">
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-zfbzf" />
                        </svg>
                        支付宝支付
                    </el-button>
                </div>
                <div class="insufficient" v-if="insufficient">
                    您的余额不足，
                    <el-button type="danger" @click="recharge">立即充值</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { baseUrl } from '../../config';
    import expertcollection from '@/components/expertcollection.vue';
    import Chat from '../../components/common/Chat';
    export default {
        components: {
            expertcollection,
            Chat
        },
        data() {
            return {
                avatar: '',
                name: '',
                city: '',
                job: '',
                describe: '',
                website: '',
                labellist: {},
                achievement: '',
                focusnum: '',
                fansnum: '',
                info: {},
                show: true,
                loading: false,
                buyDialog: false
            };
        },
        computed: {
            insufficient() {
                return (
                    Number(this.$store.state.login.userInfo.balance) <
                    Number(this.info.price)
                );
            }
        },

        created() {
            console.log(22222, this.$route.query.professor);
            this.getUserInfo();
        },
        methods: {
            getUserInfo() {
                this.loading = true;
                this.httpGet(this.$root.getUserInfo, {
                    uid: this.$route.query.professor
                })
                    .then(result => {
                        this.info = result;
                        this.avatar = result.avatar;
                        this.name = result.nickname;
                        this.city = result.provincename;
                        this.job = result.work;
                        this.describe = result.describe;
                        this.website = result.website;
                        this.labellist = result.label;
                        this.achievement = result.achievement;
                        this.focusnum = result.follownum;
                        this.fansnum = result.bfollownum;
                        this.loading = false;
                        if (this.$route.query.buid) {
                            this.toChat();
                        }
                        console.log(result);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            toChat() {
                if (!this.$store.state.login.userInfo.uid) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                if (Number(this.info.price)) {
                    this.buyDialog = true;
                    return;
                }
                this.show = false;
                this.$refs.chat.openChat();
            },
            setFollow() {
                if (!this.$store.state.login.userInfo.uid) {
                    this.$message({
                        type: 'error',
                        message: '您还没有登录，请先登录！'
                    });
                    return;
                }
                this.httpPost(this.$root.setUserFollow, {
                    followid: this.info.uid,
                    status: this.info.isfollow == 1 ? 2 : 1
                })
                    .then(result => {
                        this.getUserInfo();
                    })
                    .catch(err => {
                        console.error('setFollow-err', err);
                    });
            },
            recharge() {
                this.$router.push({
                    name: 'recharge'
                });
            },
            payCreate(way) {
                this.way = way; // 2支付宝3余额
                this.httpPost(this.$root.payCreate, {
                    way: this.way,
                    target_id: this.info.uid,
                    target_type: 2
                })
                    .then(result => {
                        if (this.way == 2) {
                            let token = this.$store.state.login.token;
                            location.href =
                                baseUrl +
                                '/pay/confirm?pay_id=' +
                                result.id +
                                '&token=' +
                                token;
                        } else if (this.way == 3) {
                            this.payConfirm(result.id);
                        }
                    })
                    .catch(err => {
                        this.buyDialog = false;
                        this.$message({
                            message: '操作失败，请刷新重试',
                            type: 'error'
                        });
                        console.error('payCreate-err', err);
                    });
            },
            payConfirm(id) {
                this.httpGet(this.$root.payConfirm, {
                    pay_id: id
                })
                    .then(result => {
                        this.$message({
                            message: '支付成功！',
                            type: 'success'
                        });
                        this.buyDialog = false;
                        this.getUserInfo();
                        this.show = false;
                        this.$refs.chat.openChat();
                    })
                    .catch(err => {
                        this.buyDialog = false;
                        this.$message({
                            message: '操作失败，请刷新重试',
                            type: 'error'
                        });
                        console.error('payConfirm-err', err);
                    });
            },
            payWx() {
                // this.way = 1;
                this.$message('暂未开通微信支付');
            }
        },
        watch: {
            '$route.query.professor': function(newPro, oldPro) {
                if (!this.loading && this.$route.name == 'expertcenter') {
                    this.getUserInfo();
                }
            }
        }
    };
</script>
<style lang="stylus"  rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .el-main {
        padding: 0;
        margin: 20px 0 0 20px;
    }

    .bodycontent {
        display: flex;
        flex-direction: row;
    }

    .leftcontent {
        margin-top: 20px;
        width: 280px;
        display: flex;
        flex-direction: column;
        background-color: white;
        border-radius: 8px;
        align-items: center;

        .avatar-icon {
            position: relative;
            margin-top: 32px;

            .icon {
                width: 30px;
                height: 30px;
                fill: #f0c328;
                position: absolute;
                right: 5px;
                top: -18px;
                transform: rotate(20deg);
                -ms-transform: rotate(20deg); /* IE 9 */
                -moz-transform: rotate(20deg); /* Firefox */
                -webkit-transform: rotate(20deg); /* Safari 和 Chrome */
                -o-transform: rotate(20deg); /* Opera */
            }
        }

        .avatar {
            width: 80px;
            height: 80px;
            border-radius: 50px;
        }

        .name {
            font-size: 16px;
            margin-top: 16px;
            font-weight: bold;
        }

        .leftmid {
            display: flex;
            flex-direction: row;
            margin-top: 4px;
            align-items: center;

            .city {
                font-size: 12px;
                opacity: 0.45;
            }

            .line {
                width: 1px;
                height: 10px;
                margin-left: 4px;
                margin-right: 4px;
                background-color: #D8D8D8;
            }
        }

        .label {
            font-size: 14px;
            opacity: 0.85;
            margin-top: 10px;
            padding: 0 24px;
        }

        .haslittle {
            padding: 0;
            flex-x(flex-start);
            flex-wrap: wrap;
        }

        .littlelabel {
            font-size: 12px;
            font-weight: bold;
            height: 26px;
            line-height: 26px;
            padding: 0 5px;
            margin-right: 8px;
            border-radius: 4px;
            border: 1px solid rgba(221, 221, 221, 1);
        }

        .website {
            font-size: 14px;
            opacity: 0.85;
            margin-top: 2px;
        }

        .buttoncontent {
            display: flex;
            flex-direction: row;
            margin-top: 20px;

            .contact {
                width: 72px;
                height: 28px;
                padding: 0;
            }
        }

        .labelcontent {
            display: flex;
            flex-direction: column;
            padding: 0 24px;
            width: 232px;

            .label {
                display: flex;
                flex-direction: row;
                // border: solid 1px;
            }

            &.left {
                flex-y(center, flex-start);
            }
        }

        .achievementcontent {
            padding: 0 24px 24px 24px;
            width: 232px;
            flex-y(center, flex-start);
            text-align: left;

            .success {
                text-align: left;
                font-size: 14px;
            }

            .successtext {
                margin-top: 8px;
                font-size: 14px;
                opacity: 0.65;
            }
        }
    }

    .leftbottom {
        border-radius: 8px;
        margin-top: 16px;
        background-color: white;
        width: 280px;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        .focus {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .focustext {
                font-size: 12px;
                opacity: 0.25;
            }

            .num {
                font-size: 16px;
                margin-top: 6px;
            }
        }
    }

    >>>.el-dialog__header {
        flex-x(space-between);

        .dialog-title {
            font-size: 16px;
            color: gray3;
            line-height: 21px;
            text-align: left;
            width: 90%;
            ellipsis();
        }
    }

    .dialog-contianer {
        padding: 24px;
        flex-y();

        .dialog-amount {
            font-size: 20px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            margin-top: 20px;
            font-weight: 500;

            span {
                color: rgba(255, 87, 31, 1);
            }
        }

        .dialog-btn {
            flex-x();
            margin: 40px 0;

            svg {
                width: 16px;
                height: 16px;
                margin-right: 12px;
            }
        }
    }

    .insufficient {
        font-size: 14px;
        color: red;
        line-height: 19px;
        margin-top: 20px;
    }

    .primary {
        margin-top: 16px;
        width: 100px;
        height: 36px;
    }
</style>
